import "./Vegas.css";

import React from "react";

function Vegas() {
    return (
        <div className="container">
            <svg viewBox="0 0 1600 300">
                <symbol id="s-text">
                    <text textAnchor="middle" x="50%" y="80%">Fabric Feud</text>
                </symbol>

                <g className="g-ants">
                    <use xlinkHref="#s-text" className="text-copy" />
                    <use xlinkHref="#s-text" className="text-copy" />
                    <use xlinkHref="#s-text" className="text-copy" />
                    <use xlinkHref="#s-text" className="text-copy" />
                    <use xlinkHref="#s-text" className="text-copy" />
                </g>
            </svg>
        </div>
    );
}

export default Vegas;
